import {all} from 'redux-saga/effects';

import agencyClients from './agency-clients';
import iframe from './iframe';
import metrika from './metrika';
import context from './context';

import notifications from './notifications';

import brandliftSagas from './brandlift';
import quicksurveySagas from './quicksurvey/';

import scroll from './scroll';

export default function* rootSaga() {
    yield all([
        agencyClients(),
        context(),
        iframe(),
        scroll(),
        metrika(),
        notifications(),
        ...brandliftSagas,
        ...quicksurveySagas
    ]);
}
